import * as React from "react";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import Note from "components/form/Note/Note";
import { BoundStringRadioButtonGroup } from "components/form/RadioButton/RadioButtonGroup";
import RadioButton from "components/form/RadioButton/RadioButton";
import {ValueInPropertiesOrErrorsHasChanged} from "utils/ShouldUpdate/ValueInPropertiesHasChanged";
import {BuiltInFeedId} from "../../client/resources/feedResource";

const StringProperties = {
    "Octopus.Action.Package.DownloadOnTentacle": "",
    "Octopus.Action.Package.FeedId": "",
    "Octopus.Action.RunOnServer": ""
};

export type PackageDownloadOptionsProperties = {
    [P in keyof typeof StringProperties]: string
};

interface PackageDownloadOptionsProps {
    projectId: string;
    localNames: string[];
    properties: PackageDownloadOptionsProperties;
    errors: {};
    setProperties(properties: Partial<PackageDownloadOptionsProperties>): void;
}

export default class PackageDownloadOptions extends BaseComponent<PackageDownloadOptionsProps, {}> {
    shouldComponentUpdate(newProps: PackageDownloadOptionsProps): boolean {
        return ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props);
    }

    componentDidMount() {
        this.props.setProperties({["Octopus.Action.Package.DownloadOnTentacle"]: this.props.properties["Octopus.Action.Package.DownloadOnTentacle"] || "False"});
    }

    render() {
        const properties = this.props.properties;

        if (
            (properties["Octopus.Action.Package.FeedId"] && properties["Octopus.Action.Package.FeedId"].toLowerCase() === BuiltInFeedId) ||
            (properties["Octopus.Action.RunOnServer"] && properties["Octopus.Action.RunOnServer"].toLowerCase() === "true")
        ) {
            return null;
        }

        return <BoundStringRadioButtonGroup
            variableLookup={{
                localNames: this.props.localNames,
                projectId: this.props.projectId
            }}
            resetValue={"False"}
            value={properties["Octopus.Action.Package.DownloadOnTentacle"]}
            onChange={(val: string) => this.props.setProperties({["Octopus.Action.Package.DownloadOnTentacle"]: val})}>
            <RadioButton
                value="False"
                label="Octopus Server will download the package, then securely upload it to the Tentacles"
                isDefault={true} />
            <RadioButton
                value="True"
                label="Each Tentacle will download the package directly from the remote server" />
            <Note>
                Applies to machines running the Tentacle deployment agent only; packages deployed to other
                endpoint types are always downloaded by the Octopus Server. {properties["Octopus.Action.RunOnServer"]}
            </Note>
        </BoundStringRadioButtonGroup>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PackageDownloadOptions/PackageDownloadOptions.tsx